import { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';

export const TextAreaControlled = (props) => {
  const {
    id,
    labelText,
    placeholderText,
    extendClass = '',
    showPopupHandler = () => {},
    onFocusCallbackHandler = () => {},
    onChangeValueHandler = () => {},
    onBlurCallbackHandler = () => {},
    hideErrors = false,
    cols,
    rows,
    showAllErrorMessages = false,
  } = props;
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext();
  const error = errors[id];
  const [isFocused, setIsFocused] = useState(false);
  const containerClasses = ['textarea-controlled input-container', extendClass].join(' ');
  const textAreaClasses = ['form-control', error ? 'has-error' : ''].join(' ');
  const hideErrorMessage = error?.type === 'required' || hideErrors;

  const onFocusHandler = () => {
    setIsFocused(true);
    showPopupHandler(id);

    onFocusCallbackHandler();
  };

  const onChangeHandler = (onChangeFunc, event) => {
    onChangeFunc(event);
    onChangeValueHandler(event.target.value);
  };

  const onBlurHandler = (onBlurFunc, event) => {
    onBlurFunc(event);
    const textAreaValue = getValues()?.[id];
    if (!textAreaValue?.length) {
      setIsFocused(false);
    }
    showPopupHandler(false);
    onBlurCallbackHandler(textAreaValue);
  };

  const getErrorMessages = () => {
    let errorMessages;
    const inputErrors = error?.types;

    if (showAllErrorMessages && inputErrors) {
      errorMessages = Object.values(inputErrors).map((errorMessage) => (
        <p className="error-message">{errorMessage}</p>
      ));
    } else {
      errorMessages = <p className="error-message">{error?.message}</p>;
    }

    return errorMessages;
  };

  return (
    <div className={containerClasses} data-testid="input-controlled">
      <Controller
        control={control}
        name={id}
        render={({ field: { value, onChange, onBlur, ref } }) => {
          const labelClasses = [
            'control-label',
            isFocused || value?.length > 0 ? 'label-focus' : '',
          ].join(' ');

          return (
            <>
              <label htmlFor={id} className={labelClasses}>
                {labelText}
              </label>
              <textarea
                className={textAreaClasses}
                cols={cols}
                id={id}
                rows={rows}
                onChange={(event) => onChangeHandler(onChange, event)}
                onFocus={onFocusHandler}
                onBlur={(event) => onBlurHandler(onBlur, event)}
                placeholder={placeholderText}
                value={value || ''}
              />
            </>
          );
        }}
      />
      {!hideErrorMessage && error && getErrorMessages()}
    </div>
  );
};

TextAreaControlled.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.string,
  placeholderText: PropTypes.string,
  extendClass: PropTypes.string,
  showPopupHandler: PropTypes.func,
  onFocusCallbackHandler: PropTypes.func,
  onBlurCallbackHandler: PropTypes.func,
  onChangeValueHandler: PropTypes.func,
  hideErrors: PropTypes.bool,
  cols: PropTypes.string,
  rows: PropTypes.string,
  showAllErrorMessages: PropTypes.bool,
};
